import { createI18n } from 'vue-i18n';
import i18nMinside from './nb-NO/translation.json';
import i18nSkattOgAvgift from './nb-NO/skattOgAvgift.json';

const i18nTotal = {
  ...i18nMinside,
  ...i18nSkattOgAvgift,
};

const i18n = createI18n({
  legacy: true,
  locale: 'no',
  fallbackLocale: 'no',
  globalInjection: true,
  messages: {
    no: i18nTotal,
  },
});

export default i18n;
